module.exports = __webpack_public_path__ + "img/tractor-green.fc7ae919.svg";